// extracted by mini-css-extract-plugin
export default {"tooltip__line":"TooltipIconValue_tooltip__line__8fSVT"};